import {Layout, Divider, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const EducationConc = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-5%'}}>Conclusions</Paragraph>
        <Text className='BaseText2'>Over the past months we have <b>created spaces and projects</b> that have enabled efficient <b>scientific dissemination</b> towards people of <b>different ages</b>, and different <b>careers</b>.<br/><br/>From children to the elderly, we looked for creative ways to engage with the public and introduce them to scientific topics, to the <b>biology of aging</b> and  to <b>synthetic biology</b> in general. Moreover, we managed to spread awareness and communicate about the importance of <b>dignified aging</b> and the <b>relevance of our project to the community</b>. Overall, we successfully addressed the misconceptions in our community about synthetic biology, aging and science communication by involving engaging content in our social networks, fun, dynamic and creative activities in the learning process.</Text>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default EducationConc;
